<template>
  <div class="footer">
    <div >
      <el-row :gutter="30">
        <!--        <div style="background-color: #1077D6;font-size: 20px;color: #ffffff;text-align: center;float: left;margin: auto;margin-left: 280px">XXXXXXXX</div>-->
        <!--        <div style="background-color: #1077D6;font-size: 20px;color: #ffffff;text-align: center;float: left;margin: auto;margin-left: 100px">XXXXXXXXXXXXXXXX</div>-->
        <!--        <div style="background-color: #1077D6;font-size: 20px;color: #ffffff;text-align: center;float: left;margin: auto;margin-left: 100px">XXXXXXXXXXXXXX</div>-->
        <!--        <div style="background-color: #1077D6;font-size: 20px;color: #ffffff;text-align: center;float: left;margin: auto;margin-left: 100px">XXXXXXXXXXXXXX</div>-->
        <!--        <div style="background-color: #1077D6;font-size: 20px;color: #ffffff;text-align: center;float: left;margin: auto;margin-left: 100px">XXXXXXXXXXXXX</div>-->
        <!--        <div style="background-color: #1077D6;font-size: 20px;color: #ffffff;text-align: center;float: left;margin: auto;margin-left: 100px">XXXXXX</div>-->
        <!--              <el-col :span="1">-->
        <!--              </el-col>-->
        <el-col :span="4" :offset="2">
          <div @click="web1('https://www.mee.gov.cn/')" style="background-color: #1077D6;font-size: 20px;color: #ffffff;text-align: center;cursor: pointer;">
            <!--            中国政府网-->
            生态环境部
          </div>
        </el-col>
        <el-col :span="4">
          <div  @click="web1('https://www.nim.ac.cn/')" style="background-color: #1077D6;font-size: 20px;color: #ffffff;text-align: center;cursor: pointer;">
            <!--            内蒙古自治区人民政府-->
            中国计量科学研究院
          </div>
        </el-col>
        <el-col :span="4">
          <div  @click="web1('https://amr.nmg.gov.cn/')" style="background-color: #1077D6;font-size: 20px;color: #ffffff;text-align: center;cursor: pointer;">
            <!--            国家各省发改委网站-->
            内蒙古自治区市场监督管理局
          </div>
        </el-col>
        <el-col :span="4">
          <div  @click="web1('https://sthjt.nmg.gov.cn/')" style="background-color: #1077D6;font-size: 20px;color: #ffffff;text-align: center;cursor: pointer;">
            <!--            自治区直属部门网站-->
            内蒙古自治区生态环境厅
          </div>
        </el-col>
        <el-col :span="4">
          <div  @click="web1('http://www.nmgjl.com.cn/')" style="background-color: #1077D6;font-size: 20px;color: #ffffff;text-align: center;cursor: pointer;">
            <!--            各盟市发改委网站-->
            内蒙古自治区计量测试研究院
          </div>
        </el-col>
        <!--        <el-col :span="2">-->
        <!--          <div style="background-color: #1077D6;font-size: 20px;color: #ffffff;text-align: center">-->
        <!--&lt;!&ndash;            相关网站&ndash;&gt;-->
        <!--            XXXXXX-->
        <!--          </div>-->
        <!--        </el-col>-->
        <!--              <el-col :span="1">-->
        <!--              </el-col>-->
      </el-row>
    </div>
    <div style="margin-top: 20px">
<!--      <p>总访问量:{{getTotalVisitsTotal}}次&nbsp;&nbsp;&nbsp;今日访问量:{{getVisitsTotal}}次&nbsp;&nbsp;&nbsp;今日活跃度:{{getActivationTotal}}人</p>-->
      <!--      <p>主办单位: 内蒙古自治区XXXXXXXX</p>-->
      <!--      <p>备案号/经营许可证号: 蒙1CP备xxxxxxxx 政府网站标识码: xxxxxxxxxx 蒙公网安备 xxxxxxxxxxxxxx号</p>-->
      <!--      <p>备案号/经营许可证号: 蒙1CP备19004152 政府网站标识码: 1500000014 蒙公网安备 15010502001014号</p>-->
    </div>
  </div>
</template>

<script>
import axios from 'axios';
// import * as SettingUpdate from "@/settingUpdate";

export default {
  // created() {
  //   this.getUserDetail()
  // },
  data() {
    return {
      getActivationTotal:0,
      getVisitsTotal:0,
      getTotalVisitsTotal:0,
    };
  },
  created() {
    // this.getVisits();
    // this.getActivation();
    // this.getTotalVisits();
  },
  methods: {
    web1(url){
      window.open(url);
    },
    // getTotalVisits(){
    //   // let that =this;
    //   // axios.get('http://111.56.142.53:17001/getTotalVisits', {params: {}}).then(res1 => {
    //   //   that.getTotalVisitsTotal=res1.data.total;
    //   //   console.log("getTotalVisitsTotal",res1);
    //   // });
    // },
    // getActivation(){
    //   // let that =this;
    //   // axios.get('http://111.56.142.53:17001/getActivation', {params: {}}).then(res1 => {
    //   //   that.getActivationTotal=res1.data.total;
    //   //   console.log("getActivationTotal",res1);
    //   // });
    // },
    getVisits(){
      let that =this;
      axios.get('http://10.8.29.15:18001/getVisits', {params: {}}).then(res1 => {
        that.getVisitsTotal=res1.data.total;
        console.log("getVisitsTotal",res1);
        axios.get('http://10.8.29.15:18001/getActivation', {params: {}}).then(res => {
          that.getActivationTotal=res.data.total;
          console.log("getActivationTotal",res);
          axios.get('http://10.8.29.15:18001/getTotalVisits', {params: {}}).then(res2 => {
            that.getTotalVisitsTotal=res2.data.total;
            console.log("getTotalVisitsTotal",res2);
          });
        });
      });
    },
    // getUserDetail(){
    //   axios.get('http://111.56.142.53:17005/api/get-tokens', {params: {
    //       id_token_hint:localStorage.getItem("accessToken"),
    //       post_logout_redirect_uri:'',
    //       state:'',
    //       userName:'fgw/'+this.account.preferred_username,
    //       // 'fgw/'+this.account.preferred_username
    //       applicationName:'application_door'
    //     }}).then(res => {
    //     console.log('getUserDetail:', res);
    //
    //   });
    // },

  }
};
</script>

<style scoped>
.footer {
  /*background: #313131;*/
  background: #137CDF;
  width: 100%;
  box-sizing: border-box;
  padding: 20px 0;

}
.footer p {
  text-align: center;
  line-height: 30px;
  color: #fff;
  font-size: 14px;
}
</style>
